import { Global, Collection, Jobs } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../components/SeoHead';

import MainBanner from '../../components/MainBanner';
import LatestNews from '../../components/LatestNews';
import AllSectors from '../../components/AllSectors';
import ImageWithTextWithOverlay from '../../components/ImageWithTextWithOverlay';
import SimpleFormWithBgImage from '../../components/SimpleFormWithBgImage';
import LatestJobs from '../../components/LatestJobs';
import LatestTestimonials from '../../components/LatestTestimonials';

export default function JobSeekersPage({
    global,
    all_news,
    all_sectors,
    all_jobs,
    all_testimonials
}) {
    return (
        <>
            <SeoHead
                page_name={`Job seekers | Staffing Agency | US and Canada Staffing | Bartech Staffing`}
                canonical_link={`job-seekers`}
            />
            <MainBanner
                global={global}
                pathPrefix={`job_seekers_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Your Gateway to Engineering, Technical & Professional Opportunities</h1>
                        <p>We work exclusively on placing talent in the best engineering, technical, and professional roles—serving all verticals and disciplines. We embrace collaboration, work-life balance, diversity, inclusion, and social responsibility as fundamental tenets for ourselves and our client partners.</p>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
            />
            <LatestJobs
                global={global}
                pathPrefix={`job_seekers_page.latest_jobs`}
                customClass={`py-5 grayGradientBg`}
                post={all_jobs}
                content={<>
                    <h2>We have more than 200 live vacancies.</h2>
                    <p>Find our latest tech and digital career opportunities.</p>
                </>
                }
                buttonTitle={``}
                buttonLink={``}
                swiperID={`latestJobsSwiper`}
                jobSearch={true}
            />
            <LatestTestimonials
                global={global}
                pathPrefix={`job_seekers_page.latest_testimonials`}
                customClass={`py-5`}
                content={
                    <>
                        <h2>Client Testimonials</h2>
                    </>
                }
                post={all_testimonials}
                swiperID={`latestTestimonialsSwiper`}
            />

            <SimpleFormWithBgImage
                global={global}
                sectionId={"join-our-talent-network"}
                pathPrefix={`job_seekers_page.simple_form_with_bg_image`}
                customClass={`py-5 position-relative yellow-bg`}
                formId={`3ead74fd-d6e8-4f05-bad3-e4940fba97f9`}
                contentSuffix={
                    <>
                        <div id="gr-score-company" className='ms-auto me-0 my-5 d-flex justify-content-start' />
                        <script async defer crossorigin="anonymous" src="https://app.greatrecruiters.com/companies/d88c53a351269290ac45693ddb2e8a7b36cd3f44/score" />
                    </>
                }
                content={
                    <>
                        <h2>Join Our Talent Network</h2>
                        <p>Are you looking to take the next steps in your career? Register your resume on this form and let our recruitment team find your next opportunity!</p>
                    </>
                }
                bgImageLink={``}
                bgImageAlt={``}
                successPageUrl={`/job-seekers/submission-success`}
            />
            <AllSectors
                global={global}
                pathPrefix={`job_seekers_page.all_sectors`}
                customClass={`py-5`}
                content={
                    <>
                        <h2>Specialist Markets</h2>
                        <p>As the house of global tech and transformation recruitment, we specialise in bringing talent solutions across the full digital spectrum to life. Each one of our solutions is built to the specific needs of our clients, with great variety in size, shape, and scale of design, but with a unifying core of deep tech sector expertise.</p>
                        <p>This gives our clients the unique advantage of tech specialism at scale. Naturally, our background means that we cover all digital skillsets, but there are specific sub-sectors where we provide even deeper levels of insight–often in the places where skills are niche, rare, competitive, or just developing. We call these our Specialist Markets.</p>
                    </>
                }
                post={all_sectors}
            />
            <LatestNews
                global={global}
                pathPrefix={`job_seekers_page.latest_news`}
                customClass={`py-5`}
                post={all_news}
                content={
                    <>
                        <h2>The Lorien Pulse: Latest News, Events, and Insights</h2>
                        <p>Our tech expertise and partner-led approach allows us to deliver highly successful results for our clients so they can attract and retain unique talent for their business. Explore our latest collection of case studies, news, events, and insights</p>
                    </>
                }
                buttonLink={`/insights/`}
                buttonTitle={`View All Insights`}
            />
            <ImageWithTextWithOverlay
                global={global}
                pathPrefix={`job_seekers_page.multi_column_cta`}
                customClass={`py-5`}
                content={
                    <>
                        <h2>Want to be featured as an Employer?</h2>
                        <p>Bartech will feature your company as one to work for! Reach out to us today to learn more.</p>
                    </>
                }
                buttonTitle={`Get in Touch`}
                buttonLink={`/contact-us/`}
                imageURL={`/site-assets/images/ask-david.jpg`}
                imageALT={`Job Seekers Featured Image`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const news = (await Collection('news'));
    const sectors = (await Collection('sectors'));

    const all_jobs = (await Jobs())
        .filter(function (job) {
            return (
                (new Date(job?.expires_at)) >= (new Date())
            )
        })
        .getItems().slice(0, 8);

    const testimonials = await Collection('client_testimonials');

    const all_testimonials = testimonials.orderBy('order').getItems();
    const all_sectors = sectors.orderBy('order').getItems().slice(0, 8);
    const all_news = news.orderBy('date').getItems().slice(0, 8);

    return {
        props: {
            global,
            all_news,
            all_sectors,
            all_jobs,
            all_testimonials
        }
    };
}
